import {
  FaClosedCaptioning,
  FaCode,
  FaCogs,
  FaDatabase,
  FaDownload,
  FaFileVideo,
  FaImage,
  FaLightbulb,
  FaMagic,
  FaPlayCircle,
  FaPuzzlePiece,
  FaRocket,
} from 'react-icons/fa';
import './index.less';

const pluginsData = [
  {
    name: '视频快剪',
    icon: <FaPlayCircle />,
    description: '一键合成视频与图片，添加BGM、配音、转场、贴纸，轻松成片',
  },
  {
    name: '图生视频',
    icon: <FaMagic />,
    description: '包含豆包、海螺、vidu、万相、可灵即梦等图片生成视频技术，激发创意',
  },
  {
    name: '字幕同步',
    icon: <FaClosedCaptioning />,
    description: '智能校准字幕与音频，打造专业视听体验',
  },
  {
    name: '音频提取',
    icon: <FaCode />,
    description: '快速提取视频音频，支持多格式输出，获取纯净音频',
  },
  {
    name: '声音克隆',
    icon: <FaImage />,
    description: '克隆专属声音，用于配音等，赋予作品独特魅力',
  },
  {
    name: '视频搜索',
    icon: <FaFileVideo />,
    description: '搜索抖音、快手、小红书、B站等平台视频搜索，轻松获取创作素材',
  },
  {
    name: '视频下载',
    icon: <FaDownload />,
    description: '下载抖音、快手、小红书、B站等平台视频，丰富创作资源',
  },
  {
    name: '数据洞察',
    icon: <FaDatabase />,
    description:
      '连接淘宝、京东、拼多多、抖音、快手、小红书、B站等各大平台，获取丰富数据，助力创作决策。',
  },
];

const workflowSteps = [
  {
    title: '定义任务',
    description: '明确您的自动化需求',
    icon: <FaLightbulb />,
  },
  {
    title: '组合插件',
    description: '选择并配置所需插件',
    icon: <FaPuzzlePiece />,
  },
  {
    title: '配置工作流',
    description: '设置执行逻辑与顺序',
    icon: <FaCogs />,
  },
  {
    title: '部署运行',
    description: '监控与优化执行效果',
    icon: <FaRocket />,
  },
];

const orderLabel = (index: number) => String(index + 1).padStart(2, '0');

const PluginsSection = () => {
  return (
    <section className="plugins-section" id="plugins">
      <div className="container">
        <header className="home-section-head">
          <span className="home-section-eyebrow">插件生态</span>
          <h2 className="home-section-title">丰富的插件和工作流</h2>
          <p className="home-section-desc">
            汇聚 180+ 核心插件、800+ 工作流，满足企业级 AI Agent 调用，支持企业与个人按需订阅。
          </p>
        </header>

        <div className="plugins-grid">
          {pluginsData.map((plugin, index) => (
            <article className="plugin-card" key={plugin.name}>
              <div className="plugin-card__top">
                <span className="plugin-card__icon">{plugin.icon}</span>
                <span className="plugin-card__index" aria-hidden>
                  {orderLabel(index)}
                </span>
              </div>
              <h3 className="plugin-title">{plugin.name}</h3>
              <p className="plugin-description">{plugin.description}</p>
            </article>
          ))}
        </div>

        <div className="workflow-panel">
          <div className="workflow-panel__intro">
            <span className="workflow-panel__eyebrow">从想法到上线</span>
            <h3 className="workflow-panel__title">四步构建自动化工作流</h3>
            <p className="workflow-panel__desc">
              从定义任务到部署运行，把插件组合成稳定可复用的自动化流程。
            </p>
          </div>

          <ol className="workflow-steps">
            {workflowSteps.map((step, index) => (
              <li className="workflow-step" key={step.title}>
                <span className="workflow-step__no" aria-hidden>
                  {orderLabel(index)}
                </span>
                <span className="workflow-step__icon">{step.icon}</span>
                <h4 className="workflow-step__title">{step.title}</h4>
                <p className="workflow-step__desc">{step.description}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
};

export default PluginsSection;
